//Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
export const SET_LOCALE = 'SET_LOCALE';
export const ADD_VOTE = 'ADD_VOTE';
export const REMOVE_VOTE = 'REMOVE_VOTE';
export const SUBMIT_VOTED = 'SUBMIT_VOTED';
export const CLEAR_VOTES = 'CLEAR_VOTES';
export const SET_CATEGORIES = 'SET_CATEGORIES';
